var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.833a6.5 6.5 0 00-6.5 6.5c0 2.515 1.64 4.98 3.476 6.917A24.354 24.354 0 0012 19.936a24.347 24.347 0 003.024-2.686c1.835-1.937 3.476-4.402 3.476-6.917a6.5 6.5 0 00-6.5-6.5zm0 17.334l-.555.831-.003-.001-.006-.004-.02-.014a9.587 9.587 0 01-.324-.228 26.362 26.362 0 01-3.568-3.126C5.609 16.605 3.5 13.652 3.5 10.333a8.5 8.5 0 1117 0c0 3.319-2.11 6.271-4.024 8.292a26.365 26.365 0 01-3.568 3.126 15.837 15.837 0 01-.325.228l-.02.014-.005.004h-.002c0 .001-.001.002-.556-.83zm0 0l.555.832-.555.37-.555-.37.555-.832z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.833a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.5 1.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.b1af990d8d231ebd3ea065d9eca33554.svg";
export { ForwardRef as ReactComponent };